import { Directive, effect } from '@angular/core';
import { getContrastYIQ } from '@common/utils/util';
import { CriteriaObj } from '@src/suite/common/data-models/criteria/criteria-obj';

import { AbstractAdornerDirective } from './abstract-adorner';

@Directive({
    selector: '[st-topic-card-type-color]',
})
export class TopicCardTypeColorDirective extends AbstractAdornerDirective {
    protected get locationID(): string {
        return this.globalTablesService.adornersIDS.TopicCardTypeColor;
    }
    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner }) {
        if (vcToApply && vcToApply.adorner && vcToApply.adorner.Color) {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', vcToApply.adorner.Color);
            this.renderer.setStyle(this.el.nativeElement, 'color', getContrastYIQ(vcToApply.adorner.Color));
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', '#DBDBDB');
            this.renderer.setStyle(this.el.nativeElement, 'color', getContrastYIQ('#DBDBDB'));
        }
    }

    constructor() {
        super();

        effect(() => {
            if (this.data()) {
                this.applyAdorner();
            }
            if (this.itemType()) {
                this.applyAdorner();
            }
        });
    }
}
